import { io, type Socket } from 'socket.io-client'

// The real ws-gateway server (apps/ws-gateway/src/server.ts's buildGateway)
// always mounts Socket.IO on the custom path '/ws/socket.io', never the
// socket.io-client default of '/socket.io/'. Omitting `path` here means the
// client's handshake requests a path the server never listens on, so the
// widget socket can never connect in any real environment (dev/prod) —
// discovered while testing the chat bubble in the Portal Configuration
// preview panel; the failure had previously been misdiagnosed as a sandbox
// WebSocket limitation in ws-gateway's own widget-namespace tests, which
// connect directly to the bare server port and hit this exact mismatch.
export function createWidgetSocket(token: string): Socket {
  return io('/widget', {
    path: '/ws/socket.io',
    auth: { token },
    transports: ['websocket'],
    autoConnect: true,
  })
}
